export default __webpack_public_path__ + "3e9d845c235be61012f1bb6dafabf1c3.png";